import { useSignals } from "@preact/signals-react/runtime";
import { signal } from "@preact/signals-react";
import { useTranslation } from "@/providers/language-provider";
import { ChatButton } from "@/features/chat-button";
import { MessageSquareMore, User, Columns2 } from "lucide-react";
import * as TabsLayout from "@/components/blocks/tabs-layout";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useChats } from "@/providers/chat-provider";

const currentTab = signal<string>("All");

export const ChatList = () => {
  useSignals();
  const { t } = useTranslation();
  const { chats, currentChat, selectChat } = useChats();

  const TAB_ITEMS = {
    All: {
      key: "All",
      label: t("All"),
      icon: <Columns2 className="h-4 w-4" />,
    },
    Friends: {
      key: "Friends",
      label: t("Friends"),
      icon: <User className="h-4 w-4" />,
    },
    Chats: {
      key: "Chats",
      label: t("Chats"),
      icon: <MessageSquareMore className="h-4 w-4" />,
    },
  } as const;

  return (
    <TabsLayout.Root
      value={currentTab.value}
      onValueChange={(value: string) => (currentTab.value = value)}
    >
      <TabsLayout.Bottom>
        <TabsLayout.Page value={TAB_ITEMS.All.key}>
          <ScrollArea className="w-full h-full">
            {chats?.all?.map((chat: any) => (
              <ChatButton
                key={chat._id}
                chat={chat}
                variant={chat._id === currentChat?._id ? "default" : "ghost"}
                onClick={() => selectChat(chat)}
                hasNewMessage={chat.hasNewMessage}
              />
            ))}
          </ScrollArea>
        </TabsLayout.Page>
        <TabsLayout.Page value={TAB_ITEMS.Friends.key}>
          <ScrollArea className="w-full h-full">
            {chats?.friends?.map((chat: any) => (
              <ChatButton
                key={chat._id}
                chat={chat}
                variant={chat._id === currentChat?._id ? "default" : "ghost"}
                onClick={() => selectChat(chat)}
                hasNewMessage={chat.hasNewMessage}
              />
            ))}
          </ScrollArea>
        </TabsLayout.Page>
        <TabsLayout.Page value={TAB_ITEMS.Chats.key}>
          <ScrollArea className="w-full h-full">
            {chats?.groups?.map((chat: any) => (
              <ChatButton
                key={chat._id}
                chat={chat}
                variant={chat._id === currentChat?._id ? "default" : "ghost"}
                onClick={() => selectChat(chat)}
                hasNewMessage={chat.hasNewMessage}
              />
            ))}
          </ScrollArea>
        </TabsLayout.Page>
      </TabsLayout.Bottom>
      <TabsLayout.Top className="border-b-0 border-t">
        {/* <TabsLayout.Label></TabsLayout.Label> */}
        <TabsLayout.Menu className="w-full">
          <TabsLayout.MenuList className="grid w-full grid-cols-3">
            {Object.values(TAB_ITEMS).map((item) => {
              return (
                <TabsLayout.MenuButton
                  className="space-x-1 items-center"
                  key={item.key}
                  value={item.key}
                >
                  {item.icon}
                  <p>{item.label}</p>
                </TabsLayout.MenuButton>
              );
            })}
          </TabsLayout.MenuList>
        </TabsLayout.Menu>
      </TabsLayout.Top>
    </TabsLayout.Root>
  );
};
